import {JsonMember, JsonObject} from "typedjson-npm";

@JsonObject
export class AttrValue  {
    @JsonMember({type: String})
    internalValue: string;
    @JsonMember({type: String})
    displayValue: string;
}

@JsonObject
export class AttributeList {
    @JsonMember({type: AttrValue})
    attributeValue: AttrValue;
}

@JsonObject
export class AttrWithValues {
    @JsonMember({elements: AttributeList})
    attributeValueWithInferredValues: AttributeList[];
}
@JsonObject
export default class RoutineAttribute {
    @JsonMember({type: AttrWithValues})
    intensity: AttrWithValues;
    @JsonMember({type: AttrWithValues})
    meal_slot: AttrWithValues;
    @JsonMember({type: AttrWithValues})
    cuisine: AttrWithValues;
    @JsonMember({type: AttrWithValues})
    diet_type: AttrWithValues;
    @JsonMember({type: AttrWithValues})
    exercise_type: AttrWithValues;
    @JsonMember({type: AttrWithValues})
    meditation_type: AttrWithValues;
}
